export default "__VITE_ASSET__DRN9u6Bc__"